import Column from '@components/Column';

import NewsContents from './NewsContents';
import OfficialChannels from './OfficialChannels';
import OrderContents from './OrderContents';
import styles from './styles.module.scss';

function SidebarContents() {
  return (
        <Column fullWidth className={styles.container}>
            <OrderContents/>
            <NewsContents/>
            <OfficialChannels/>
        </Column>
  );
}

export default SidebarContents;
